export interface IncomingChatNotification { id: string; chatId: string; senderId: string }

/** One instance belongs to one feature, role and account; history seeds never alert. */
export class ChatNotificationGate {
  private seen = new Set<string>();
  private lastSound = -Infinity;
  private accountId: string;
  private cooldown: number;
  constructor(accountId: string, cooldown = 1500) { this.accountId = accountId; this.cooldown = cooldown; }

  private remember(message: Pick<IncomingChatNotification, "id" | "chatId">): boolean {
    if (!message.id || !message.chatId) return false;
    const key = message.chatId + ":" + message.id;
    if (this.seen.has(key)) return false;
    this.seen.add(key);
    if (this.seen.size > 2000) this.seen.delete(this.seen.values().next().value!);
    return true;
  }

  rememberMessages(messages: readonly Pick<IncomingChatNotification, "id" | "chatId">[]): void {
    messages.forEach(message => this.remember(message));
  }

  shouldNotify(message: IncomingChatNotification, options: { muted: boolean; unlocked: boolean; now: number }): boolean {
    const fresh = this.remember(message);
    if (!fresh || !this.accountId || !message.senderId || message.senderId === this.accountId ||
        options.muted || !options.unlocked || options.now - this.lastSound < this.cooldown) return false;
    this.lastSound = options.now;
    return true;
  }
}
